<template>
    <div>
        <MonthlyCheckReportHistory :year="year" :month="month" :day="day" :manager="manager"/>
    </div>
</template>

<script>
    // @ is an alias to /src
    import MonthlyCheckReportHistory from '@/app/components/MonthlyCheckReportHistory.vue'

    export default {
        name: 'monthlyCheckReportHistoryIndex',
        components: {
            MonthlyCheckReportHistory
        },
        props:{
            year: {
                type: Number,
                required: true,
            },
            month: {
                type: Number,
                required: true,
            },
            day: {
                type: Number,
                required: true,
            },
            manager: {
                type: Number,
                required: true,
            }
        },
    }
</script>
